import { WORKER_TYPES } from "../types";

const initialState = {
  processStatus: undefined,
  success: undefined,
  error: undefined,
};

export const workerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case WORKER_TYPES.PROCESS_START:
      return { ...state, success: false, error: undefined ,processStatus:'Started'}; 
    case WORKER_TYPES.PROCESS_SUCCESS:
      return { ...state, success: true, error: undefined,processStatus:'Ended' };
    case WORKER_TYPES.PROCESS_FAIL:
      return { ...state, success: false, error: payload,processStatus:'Ended' }; 
   
    default:
      return state;
  }
};
